import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  CompareQuotesTableWrap,
  CurrentQuoteTableBox,
} from "./ManageBundlesStyled";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Constants, DialogConstants } from "./Content";
import { AccountDataRevenueCard } from "./AccountDataInfoCard";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  approveBundle,
  calculateBundleDiscount,
  duplicateBundle,
  getBundleDetailsForManageBundles,
  getBundleNotes,
  getBundleUploadDataByBundleId,
  getPendingApprovalRolesForBundle,
  getUsersByRole,
  refreshBundle,
  rejectBundle,
  saveBundleName,
  saveBundleNote,
  saveCrmBundleId,
  validateBundle,
  validateBundleApproval,
} from "../../Actions/QuoteAction";
import { Congiguration } from "../../Constants/AppConstants";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Severity } from "../utilities/Notification/NotificationContent";
import { addBundledProduct } from "../../Actions/CRMAction";
import BundleOpportunityDetails from "../CompareQuote/BundleOpportunityDetails";
import OkayDialog from "../utilities/Dialog/SimpleOkayDialog";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import moment from "moment";
import { BUNDLEVALIDATIONSTATUS, DISCOUNTMODE } from "../CompareQuote/Content";
import ManageBundleActions from "./ManageBundleAction";
import { statusColors } from "../CompareQuote/Data";
import ViewBundleNotesDialog from "./ViewBundleNotesDialog";
import checkIcon from "../../images/checkIcon.svg";
import closeIcon from "../../images/closeIcon.svg";
import AddBundleNoteDialog from "./AddBundleNoteDialog";
import { notifyApproverForBundleApproval } from "../../Actions/CommonAction";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import FilledInput from "@mui/material/FilledInput";
import ClearIcon from "@mui/icons-material/Clear";
import Grid from "@mui/material/Grid";
import ApprovalWorkflowDialog from "../ViewRequest/ApprovalWorkflowDialog";
import { Content } from "../ViewRequest/Content";
import Approval from "../utilities/Approval/Approval";
import ConfirmationDialog from "../utilities/Dialog/Confirmation";

const ManageBundleAccordian = ({
  quoteHeaders,
  bundleArrayObject,
  loggedUser,
  bundleRevenue,
  showNotification,
  searchText,
  updateBundleByIndex,
  prepareAndUpdateBundleObject,
  removeBundleFromList,
  samLeadershipData,
  pendingApproverRoles,
}) => {
  const dispatch = useDispatch();
  const [bundleArray, setBundleArray] = useState(bundleArrayObject);
  const [bundleRevenueData, setBundleRevenueData] = useState(
    bundleRevenue ? bundleRevenue : [],
  );
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("");
  const [duplicateBundleDetails, setDuplicateBundleDetails] = useState(null);
  const [
    currentBundleDetailsForDuplicateValidation,
    setcurrentBundleDetailsForDuplicateValidation,
  ] = useState(null);
  const [showDuplicateDialogBox, setShowDuplicateDialogBox] = useState(false);
  const [rejectDialogBox, setRejectDialogBox] = useState(false);
  const [expanded, setExpanded] = React.useState("");
  const [showBundleNotesDialog, setShowBundleNotesDialog] = useState(false);
  const [notes, setNotes] = useState([]);
  const [showAddBundleNotes, setShowAddBundleNotes] = useState(false);
  const [showNotifyDialog, setShowNotifyDialog] = useState(false);
  const [showRejectDialog, setShowRejectDialog] = useState(false);
  const [isReject, setIsReject] = useState(false);
  const [noteText, setNoteText] = useState("");
  const [currentBundleIdForAddNotes, setCurrentBundleIdForAddNotes] =
    useState(null);
  const [currentBundleIdForViewNotes, setCurrentBundleIdForViewNotes] =
    useState(null);
  const [currentBundleIdForNotify, setCurrentBundleIdForNotify] =
    useState(null);
  const [currentBundleIdForReject, setCurrentBundleIdForReject] =
    useState(null);
  const [approvalInProgress, setApprovalInProgress] = useState(false);
  const [notifyInProgress, setNotifyInProgress] = useState(false);
  const [rejectInProgress, setRejectInProgress] = useState(false);
  const [approverError, setApproverError] = useState("");
  const [dialogError, setDialogError] = useState("");
  const [approverId, setApproverId] = useState(0);
  const [notifyApproverObject, setNotifyApproverObject] = useState(null);
  const [isEditBundleName, setIsEditBundleName] = useState(false);
  const [
    currentBundleIdForEditBundleName,
    setCurrentBundleIdForEditBundleName,
  ] = useState(null);
  const [newBundleName, setNewBundleName] = useState("");
  const [dialogApproverRoles, setDialogApproverRoles] = useState([]);
  const [isOptionalApprover, setIsOptionalApprover] = useState(false);
  const [isApprovalWorkflowDialogVisible, setIsApprovalWorkflowDialogVisible] =
    useState(false);
  const [dialogText, setDialogText] = useState("");

  const handleTextBoxChange = (value) => {
    if (value) {
      setDialogText(value);
    } else {
      setDialogText("");
    }
  };

  const handleAccordianOnChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const openDuplicateDialogBox = () => {
    setShowDuplicateDialogBox(true);
  };
  const closeDuplicateDialogBox = () => {
    setShowDuplicateDialogBox(false);
  };
  const openRejectDialog = () => {
    setShowRejectDialog(true);
  };
  const closeRejectDialog = () => {
    setShowRejectDialog(false);
    setCurrentBundleIdForReject(null);
  };
  const openNotifyDialog = (e, bundleId) => {
    debugger;
    setCurrentBundleIdForNotify(bundleId);
    setShowNotifyDialog(true);
  };
  const closeNotifyDialog = () => {
    setShowNotifyDialog(false);
    setCurrentBundleIdForNotify(null);
  };

  useEffect(() => {
    setBundleArray(bundleArrayObject);
  }, [bundleArrayObject]);

  useEffect(() => {
    if (!showAddBundleNotes) {
      setCurrentBundleIdForAddNotes(null);
    }
  }, [showAddBundleNotes]);

  useEffect(() => {
    if (!showNotifyDialog) {
      setCurrentBundleIdForNotify(null);
    }
  }, [showNotifyDialog]);

  useEffect(() => {
    if (!showRejectDialog) {
      setCurrentBundleIdForReject(null);
    }
  }, [showRejectDialog]);

  useEffect(() => {
    if (!showBundleNotesDialog) {
      setCurrentBundleIdForViewNotes(null);
    }
  }, [showBundleNotesDialog]);

  useEffect(() => {
    setExpanded("");
  }, [searchText]);

  useEffect(() => {
    setBundleRevenueData(bundleRevenue);
  }, [bundleRevenue]);

  const calculateDiscountOnBundle = (
    discountMode,
    discountValue,
    bundleId,
    rateSum,
  ) => {
    let discount = discountValue;
    if (discountMode === DISCOUNTMODE.VALUE) {
      discount = (discountValue / rateSum) * 100;
    }
    const calculateBundleParams = {
      bundleId: bundleId,
      discount: discount,
      companyId: Congiguration.CompanyId,
      userId: loggedUser?.user?.id,
    };
    setLoading(true);
    setLoadingText("Calculating...");
    dispatch(calculateBundleDiscount(calculateBundleParams))
      .then((data) => {
        setLoading(false);
        setLoadingText("");
        updateBundleByIndex(data, bundleId);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setLoadingText("");
      });
  };

  const handleRefreshBundle = (bundleId) => {
    if (bundleId && bundleId !== null) {
      const refreshBundleObj = {
        bundleId: bundleId,
        userId: loggedUser?.user?.id,
      };
      setLoading(true);
      setLoadingText("Getting bundle details...");
      dispatch(refreshBundle(refreshBundleObj))
        .then((data) => {
          setLoading(false);
          setLoadingText("");
          updateBundleByIndex(data, bundleId);
        })
        .catch((e) => {
          console.log(e);
          setLoading(false);
          setLoadingText("");
        });
    }
  };

  const handleOkayToDuplicateQuotesInBundle = () => {
    if (bundleApproveObj && bundleApproveObj !== null) {
      const discountPercent =
        bundleApproveObj.discountMode === DISCOUNTMODE.PERCENT
          ? bundleApproveObj.discountValue
          : (bundleApproveObj.discountValue / bundleApproveObj.rateTotal) * 100;

      const discountValue =
        bundleApproveObj.discountMode === DISCOUNTMODE.VALUE
          ? bundleApproveObj.discountValue
          : null;

      const payload = {
        bundleId: bundleApproveObj.bundleId,
        discountPercent: discountPercent,
        discountValue: discountPercent,
        userId: loggedUser?.user?.id,
        companyId: Congiguration.CompanyId,
      };
      dispatch(duplicateBundle(payload))
        .then((res) => {
          if (res == 1) {
            handleApproveButtonClick(bundleApproveObj);
            closeDuplicateDialogBox();
          } else {
            showNotification(
              Severity.ERROR,
              Constants.MESSAGE_SOMETHINGWENTWRONG_DUPLICATE,
            );
            closeDuplicateDialogBox();
          }
        })
        .catch((e) => {
          console.log(e);
          setLoading(false);
          setLoadingText("");
          showNotification(
            Severity.ERROR,
            Constants.MESSAGE_SOMETHINGWENTWRONG,
          );
          closeDuplicateDialogBox();
        });
    }
  };

  function closeApprovalWorkflowDialog() {
    setApproverError("");
    setDialogError("");
    setDialogText("");
    setApproverId(0);
    setIsApprovalWorkflowDialogVisible(false);
  }

  useEffect(() => {
    if (!dialogApproverRoles.length) return;
    loadApprovers(dialogApproverRoles);
  }, [dialogApproverRoles]);

  const [selectedApprovers, setSelectedApprovers] = useState({});
  const [approverUsers, setApproverUsers] = useState([]);
  const loadApprovers = async (roles) => {
    try {
      const results = await Promise.all(
        roles.map(async (roleId) => {
          const users = await dispatch(getUsersByRole(roleId));

          return users.map((user) => ({
            ...user,
            roleId,
          }));
        }),
      );

      const mergedUsers = results.flat();

      setApproverUsers(mergedUsers);
    } catch (error) {
      console.error("Failed to load approvers", error);
    }
  };

  const availableApprovers = approverUsers;

  const [bundleApproveObj, setBundleApproveObj] = useState(null);

  const handleApproveButtonClick = async (bundleApproveObj) => {
    setLoading(true);
    try {
      setBundleApproveObj(bundleApproveObj);
      const discountPercent =
        bundleApproveObj.discountMode === DISCOUNTMODE.PERCENT
          ? bundleApproveObj.discountValue
          : (bundleApproveObj.discountValue / bundleApproveObj.rateTotal) * 100;
      const discountValue =
        bundleApproveObj.discountMode === DISCOUNTMODE.VALUE
          ? bundleApproveObj.discountValue
          : null;
      const payload = {
        bundleId: bundleApproveObj.bundleId,
        userId: loggedUser?.user?.id,
        roleId: loggedUser?.userRole?.[0]?.id,
        discountPercent: discountPercent,
        discountValue: discountValue,
        comments: noteText,
        selectedApprovers: [],
      };

      const response = await dispatch(validateBundleApproval(payload));

      if (response?.isQuotesFinalApproval) {
        if (response?.isDuplicateQuotesNeeded) {
          openDuplicateDialogBox();
        } else {
          setDialogApproverRoles(response.pendingApproverRoles);
          setIsOptionalApprover(response?.optionalApproval);
          setIsApprovalWorkflowDialogVisible(true);
        }
      } else {
        showNotification(
          Severity.WARNING,
          response?.message ||
            "Bundle approval validation failed. Please check quote status and try again.",
        );
      }
    } catch (error) {
      console.error("Failed to validate bundle approval", error);
      showNotification(Severity.ERROR, Constants.MESSAGE_SOMETHINGWENTWRONG);
    } finally {
      setLoading(false);
    }
  };

  const handleDialogConfirmApprove = () => {
    dispatchApproveRequest(selectedApprovers);
    setIsApprovalWorkflowDialogVisible(false);
  };

  function validateAndProcessApprovers(selectedApprovers, isOptional) {
    const approverArray = Object.values(selectedApprovers);

    if (!approverArray || approverArray.length === 0) {
      return [];
    }

    const normalizedApprovers = approverArray
      .filter((approver) => approver && typeof approver === "object")
      .map((approver) => {
        const roleId = Number(approver.roleId);
        const rawUserId = approver.userId;

        let userId = null;
        if (typeof rawUserId === "string") {
          const trimmed = rawUserId.trim();
          userId = trimmed === "" ? null : trimmed;
        } else if (typeof rawUserId === "number") {
          userId = Number.isFinite(rawUserId) && rawUserId > 0 ? rawUserId : null;
        }

        return {
          roleId: Number.isInteger(roleId) && roleId > 0 ? roleId : null,
          userId,
        };
      });

    const validApprovers = normalizedApprovers.filter(
      (approver) => approver.roleId && approver.userId !== null,
    );

    if (!isOptional && validApprovers.length !== normalizedApprovers.length) {
      throw new Error(
        "All selected approvers must have valid userId and roleId",
      );
    }

    return validApprovers;
  }

  const dispatchApproveRequest = async (selectedApprovers) => {
    setLoading(true);

    try {
      // Validate and process selectedApprovers
      let processedApprovers = [];
      try {
        processedApprovers = validateAndProcessApprovers(
          selectedApprovers,
          isOptionalApprover,
        );
      } catch (validationError) {
        showNotification(Severity.ERROR, validationError.message);
        setLoading(false);
        return;
      }

      const discountPercent =
        bundleApproveObj.discountMode === DISCOUNTMODE.PERCENT
          ? bundleApproveObj.discountValue
          : (bundleApproveObj.discountValue / bundleApproveObj.rateTotal) * 100;

      const discountValue =
        bundleApproveObj.discountMode === DISCOUNTMODE.VALUE
          ? bundleApproveObj.discountValue
          : null;

      const payload = {
        bundleId: bundleApproveObj.bundleId,
        userId: loggedUser?.user?.id,
        roleId: loggedUser?.userRole?.[0]?.id,
        discountPercent: discountPercent,
        discountValue: discountValue,
        comments: dialogText,
        selectedApprovers: processedApprovers, // Send validated approvers or empty array
      };

      const response = await dispatch(approveBundle(payload));

      if (response?.payload?.requiresMoreApprovals) {
        showNotification(
          Severity.INFO,
          `Waiting for approvals from ${response.payload.pendingApproverRoles.join(", ")}`,
        );
      } else {
        showNotification(Severity.INFO, "Approval successful");
      }

      handleRefreshBundle(bundleApproveObj.bundleId);
    } catch (err) {
      console.error("Approval Error:", err);
      showNotification(Severity.ERROR, "Approval failed");
    } finally {
      setLoading(false);
    }
  };

  // const startBundleApprovalProcess = (
  //   bundleId,
  //   discount,
  //   discountMode,
  //   rateTotal,
  // ) => {
  //   const currentBundleValidationObj = {
  //     bundleId: bundleId,
  //     discount: discount,
  //     discountMode: discountMode,
  //     rateTotal: rateTotal,
  //   };
  //   setcurrentBundleDetailsForDuplicateValidation(currentBundleValidationObj);
  //   if (bundleId && bundleId !== null && bundleId !== "") {
  //     setLoading(true);
  //     setLoadingText("Approving bundle..");
  //     dispatch(validateBundle(bundleId))
  //       .then((validationStatus) => {
  //         if (validationStatus && validationStatus !== null) {
  //           const discountPercent =
  //             discountMode === DISCOUNTMODE.PERCENT
  //               ? discount
  //               : (discount / rateTotal) * 100;
  //           const discountValue =
  //             discountMode === DISCOUNTMODE.VALUE ? discount : null;

  //           if (
  //             validationStatus?.validationCode ===
  //             BUNDLEVALIDATIONSTATUS.VALIDATION_FAILURE_QUOTES_ALREADY_APPROVED
  //               .Code
  //           ) {
  //             //Duplicate
  //             setDuplicateBundleDetails({
  //               bundleId: bundleId,
  //               discountPercent: discountPercent,
  //               discountValue: discountValue,
  //               userId: loggedUser?.user?.id,
  //               companyId: Congiguration.CompanyId,
  //             });
  //             openDuplicateDialogBox();
  //           } else if (
  //             validationStatus?.validationCode ===
  //               BUNDLEVALIDATIONSTATUS.VALIDATION_SUCCESS_APPROVE.Code &&
  //             (discount === "" || discount === null || discount === 0)
  //           ) {
  //             //Approve and Add to CRM
  //             const approveBundleObj = {
  //               bundleId: bundleId,
  //               discountPercent: discountPercent,
  //               discountValue: discountValue,
  //               userId: loggedUser?.user?.id,
  //               companyId: Congiguration.CompanyId,
  //             };
  //             setApprovalInProgress(true);
  //             approveTheBundle(approveBundleObj, true);
  //             //handleRefreshBundle(bundleId);
  //             GetBundledProductDetailsAndAddToCrm(bundleId);
  //           } else if (
  //             validationStatus?.validationCode ===
  //               BUNDLEVALIDATIONSTATUS.VALIDATION_SUCCESS_APPROVE.Code &&
  //             discount !== "" &&
  //             discount !== null &&
  //             discount !== 0
  //           ) {
  //             //Assign to pricing team
  //             const approveBundleObj = {
  //               bundleId: bundleId,
  //               discountPercent: discountPercent,
  //               discountValue: discountValue,
  //               userId: loggedUser?.user?.id,
  //               companyId: Congiguration.CompanyId,
  //             };
  //             setApprovalInProgress(true);
  //             approveTheBundle(approveBundleObj, false);
  //             //handleRefreshBundle(bundleId);
  //           } else {
  //             let result = null;
  //             Object.keys(BUNDLEVALIDATIONSTATUS).forEach((status) => {
  //               if (
  //                 BUNDLEVALIDATIONSTATUS[status]?.Code ===
  //                 validationStatus?.validationCode
  //               ) {
  //                 result = BUNDLEVALIDATIONSTATUS[status];
  //               }
  //             });
  //             if (result && result !== null)
  //               showNotification(Severity.ERROR, result.Message);
  //             else
  //               showNotification(
  //                 Severity.ERROR,
  //                 Constants.MESSAGE_SOMETHINGWENTWRONG,
  //               );
  //           }
  //         }
  //         setLoading(false);
  //         setLoadingText("");
  //       })
  //       .catch((e) => {
  //         console.log(e);
  //         showNotification(
  //           Severity.ERROR,
  //           Constants.MESSAGE_SOMETHINGWENTWRONG,
  //         );
  //       });
  //   }
  // };

  // const approveTheBundle = (approveBundleObj, isFinalApproval) => {
  //   if (approveBundleObj && approveBundleObj !== null) {
  //     dispatch(approveBundle(approveBundleObj))
  //       .then((res) => {
  //         setApprovalInProgress(false);
  //         if (res === 1) {
  //           showNotification(
  //             Severity.SUCCESS,
  //             isFinalApproval
  //               ? Constants.MESSAGE_BUNDLEAPPROVED
  //               : Constants.MESSAGE_BUNDLESUBMITTED_TOPRICINGTEAM,
  //           );
  //           //updateCanSubmitFlag(0, approveBundleObj);
  //           getBundleDetailsById(approveBundleObj?.bundleId);
  //         } else if (res === 0) {
  //           showNotification(
  //             Severity.ERROR,
  //             Constants.MESSAGE_BUNDLEAPPROVEDERROR,
  //           );
  //         }
  //       })
  //       .catch((e) => {
  //         console.log(e);
  //         showNotification(
  //           Severity.ERROR,
  //           Constants.MESSAGE_BUNDLEAPPROVEDERROR,
  //         );
  //       });
  //   }
  // };

  // const getBundleDetailsById = (bundleId) => {
  //   if (bundleId && bundleId !== null) {
  //     const bundleDetailsObj = {
  //       bundleId: bundleId,
  //       companyId: Congiguration.CompanyId,
  //       userId: loggedUser?.user?.id,
  //     };
  //     dispatch(getBundleDetailsForManageBundles(bundleDetailsObj))
  //       .then((res) => {
  //         if (res && res !== null) {
  //           prepareAndUpdateBundleObject(res, bundleId);
  //         }
  //       })
  //       .catch((e) => {
  //         console.log(e);
  //       });
  //   }
  // };

  //TODO Remove this and get updated values from DB
  // const updateCanSubmitFlag = (value, approveBundleObj) => {
  //   const bundleId = approveBundleObj?.bundleId;
  //   let existingBundleArray = [...bundleArray];
  //   let bundleObj = existingBundleArray.find(
  //     (b) => b[0]?.bundleDetails?.bundleId === bundleId,
  //   );
  //   let bundleObjIndex = existingBundleArray.findIndex(
  //     (b) => b[0]?.bundleDetails?.bundleId === bundleId,
  //   );
  //   if (bundleObj) {
  //     bundleObj.map((quote) => {
  //       quote.canSubmit = value;
  //     });
  //     existingBundleArray.splice(bundleObjIndex, 1, bundleObj);
  //   }
  //   setBundleArray(existingBundleArray);
  // };

  // const GetBundledProductDetailsAndAddToCrm = (bundleId) => {
  //   if (bundleId && bundleId !== null) {
  //     dispatch(getBundleUploadDataByBundleId(bundleId))
  //       .then((data) => {
  //         const bundleObj = PrepareCrmBundleObject(data);
  //         AddBundleToCRM(bundleObj, bundleId);
  //       })
  //       .catch((e) => {
  //         showNotification(
  //           Severity.ERROR,
  //           Constants.MESSAGE_SOMETHINGWENTWRONG,
  //         );
  //         console.log(e);
  //       });
  //   }
  // };

  // const AddBundleToCRM = (bundleObj, bundleId) => {
  //   if (bundleObj && bundleObj !== null) {
  //     dispatch(addBundledProduct(bundleObj))
  //       .then((data) => {
  //         saveCrmBundleIdInCpq({
  //           bundleId: bundleId,
  //           crmBundleId: data?.crMbundleId,
  //         });
  //         showNotification(
  //           Severity.SUCCESS,
  //           Constants.MESSAGE_BUNDLEADDTOCRMUCCESS,
  //         );
  //       })
  //       .catch((e) => {
  //         console.log(e);
  //         showNotification(
  //           Severity.ERROR,
  //           Constants.MESSAGE_SOMETHINGWENTWRONG_ADDBUNDLETOCRM,
  //         );
  //       });
  //   }
  // };

  // const saveCrmBundleIdInCpq = (saveCrmBundleIdObj) => {
  //   if (saveCrmBundleIdObj && saveCrmBundleIdObj !== null) {
  //     dispatch(saveCrmBundleId(saveCrmBundleIdObj))
  //       .then((res) => {
  //         console.log("save crm bundle id", res);
  //       })
  //       .catch((e) => {
  //         console.log(e);
  //       });
  //   }
  // };

  // const PrepareCrmBundleObject = (bundleData) => {
  //   const quotes = bundleData?.crmBundleQuotes?.map((quote) => {
  //     return {
  //       opportunitId: quote?.crmBundleQuote?.oppurtunityId,
  //       productId: quote?.crmBundleQuote?.crmProductId,
  //       session: quote?.crmBundleQuote?.sessions,
  //       hours: quote?.crmBundleQuote?.hours,
  //       utilization: quote?.crmBundleQuote?.utilization,
  //       rate: quote?.crmBundleQuote?.rate,
  //       pricingStrucutre: `${quote?.crmBundleQuote?.pricingStructureCode}`,
  //       quoteId: quote?.crmBundleQuote?.quoteId,
  //       currencyId: quote?.crmBundleQuote?.currencyCode,
  //       seatCount: quote?.crmBundleQuote?.seatCount,
  //       populations: quote?.crmQuoteCountryHeadCounts?.map((population) => {
  //         return {
  //           countryId: population?.crmCountryId,
  //           country: population?.countryName,
  //           headCount: population?.headcount,
  //           region: population?.region,
  //         };
  //       }),
  //       componentList: quote?.crmQuoteComponents?.map((component) => {
  //         return {
  //           name: component?.componentName,
  //           componentId: component?.crmComponentId,
  //         };
  //       }),
  //     };
  //   });

  //   const bundleObj = {
  //     opportunitId: bundleData?.bundleDetails?.oppurtunityId,
  //     cpQbundleId: bundleData?.bundleDetails?.bundleId,
  //     rate: bundleData?.bundleDetails?.rate,
  //     productId: bundleData?.bundleDetails?.crmProductId,
  //     currencyId: bundleData?.bundleDetails?.currencyCode,
  //     pricingStrucutre: `${bundleData?.bundleDetails?.pricingStructureCode}`,
  //     bundleQuotes: quotes,
  //   };

  //   return bundleObj;
  // };

  const viewQuoteClick = (quoteId) => {
    sessionStorage.setItem("quoteIdFromVisualize", quoteId);
    window.open(`/viewquote`, "_blank").focus();
  };

  const handleAddBundleNote = () => {
    if (currentBundleIdForAddNotes && currentBundleIdForAddNotes !== null) {
      if (noteText) {
        let newNote = {
          bundleId: currentBundleIdForAddNotes,
          message: noteText,
          isReject: isReject,
          userId: loggedUser?.user?.id,
        };
        saveNote(newNote);
      }
    }
  };

  const saveNote = (bundleNote, isNotify = false) => {
    if (bundleNote && bundleNote !== null) {
      dispatch(saveBundleNote(bundleNote))
        .then((res) => {
          if (res === 1) {
            setNoteText("");
            getBundleNoteList(bundleNote.bundleId);
            CloseAddBundleNotesDialog();
            if (!isNotify) {
              showNotification(
                Severity.SUCCESS,
                Constants.DIALOG_MESSAGE_NOTEADDSUCCESS,
              );
            }
          } else {
            showNotification(
              Severity.ERROR,
              Constants.DIALOG_MESSAGE_NOTEADDERROR,
            );
          }
        })
        .catch((e) => {
          console.log(e);
          showNotification(
            Severity.ERROR,
            Constants.MESSAGE_SOMETHINGWENTWRONG,
          );
        });
    }
  };

  const getBundleNoteList = (bundleId) => {
    setLoading(true);
    if (bundleId && bundleId !== null) {
      dispatch(getBundleNotes(bundleId))
        .then((res) => {
          setLoading(false);
          if (res && res !== null) {
            updateBundleNotes(...[res], bundleId);
          }
        })
        .catch((e) => {
          console.log(e);
          setLoading(false);
        });
    }
  };

  const updateBundleNotes = (notes, bundleId) => {
    let existingBundleArray = [...bundleArray];
    let bundleObj = existingBundleArray.find(
      (b) => b[0]?.bundleDetails?.bundleId === bundleId,
    );
    let bundleObjIndex = existingBundleArray.findIndex(
      (b) => b[0]?.bundleDetails?.bundleId === bundleId,
    );
    if (bundleObj) {
      bundleObj.map((quote) => {
        quote.bundleDetails.notes = [...notes];
      });
      existingBundleArray.splice(bundleObjIndex, 1, bundleObj);
    }
    setBundleArray(existingBundleArray);
  };

  const updateBundleName = (bundleId, bundleName) => {
    let existingBundleArray = [...bundleArray];
    let bundleObj = existingBundleArray.find(
      (b) => b[0]?.bundleDetails?.bundleId === bundleId,
    );
    let bundleObjIndex = existingBundleArray.findIndex(
      (b) => b[0]?.bundleDetails?.bundleId === bundleId,
    );
    if (bundleObj) {
      bundleObj.map((quote) => {
        quote.bundleDetails.bundleNameByUser = bundleName;
        quote.bundleDetails.bundleName = bundleName
          ? quote.bundleDetails.bundleNameOnly + "-" + bundleName
          : quote.bundleDetails.bundleNameOnly;
      });
      existingBundleArray.splice(bundleObjIndex, 1, bundleObj);
    }
    setBundleArray(existingBundleArray);
  };

  const handleViewBundleNotes = (event, bundleId) => {
    if (bundleId && bundleId !== null) {
      OpenBundleNotesDialog();
      getBundleNoteList(bundleId);
    }
  };

  const OpenBundleNotesDialog = () => {
    setShowBundleNotesDialog(true);
  };
  const CloseBundleNotesDialog = () => {
    setShowBundleNotesDialog(false);
  };
  const OpenAddBundleNotesDialog = () => {
    setShowAddBundleNotes(true);
  };
  const CloseAddBundleNotesDialog = () => {
    setShowAddBundleNotes(false);
  };

  const handleDialogTextChange = (value) => {
    if (value) {
      setNoteText(value);
    } else {
      setNoteText("");
    }
  };

  const getFormattedDiscount = (discount) => {
    const formattedDiscount = discount?.toLocaleString("en", {
      useGrouping: true,
      roundingMode: "trunc",
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
    return formattedDiscount
      ? formattedDiscount > 0
        ? "+" + formattedDiscount
        : formattedDiscount
      : "0";
  };

  const getManageBundleAccordianHeader = (bundledQuotes) => {
    return (
      <Grid container wrap="nowrap" sx={{ color: "#000" }}>
        <Grid
          item
          sm={
            isEditBundleName &&
            currentBundleIdForEditBundleName ===
              bundledQuotes[0]?.bundleDetails?.bundleId
              ? 2.8
              : 1.7
          }
          zeroMinWidth
          title={bundledQuotes[0]?.bundleDetails?.bundleName}
        >
          {isEditBundleName &&
          currentBundleIdForEditBundleName ===
            bundledQuotes[0]?.bundleDetails?.bundleId ? (
            <Box>
              <FormControl
                variant="filled"
                onClick={(e) => {
                  e.stopPropagation();
                }}
                title={bundledQuotes[0]?.bundleDetails?.bundleName}
              >
                <FilledInput
                  //className="txtDiscount"
                  id="filled-adornment-weight"
                  startAdornment={
                    <InputAdornment position="start">
                      {bundledQuotes[0]?.bundleDetails?.bundleNameOnly + "-"}
                    </InputAdornment>
                  }
                  endAdornment={
                    <InputAdornment position="end">
                      <Grid container>
                        <Grid item>
                          <CheckOutlinedIcon
                            sx={{
                              color: "rgb(35, 145, 85)",
                              "&:hover": {
                                backgroundColor: "lightGray",
                                cursor: "pointer",
                              },
                            }}
                            fontSize="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSaveBundleName(
                                e,
                                bundledQuotes[0]?.bundleDetails?.bundleId,
                              );
                            }}
                          />
                        </Grid>
                        <Grid item>
                          <ClearIcon
                            sx={{
                              "&:hover": {
                                cursor: "pointer",
                                backgroundColor: "lightGray",
                              },
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleCancelEditBundleName();
                            }}
                            fontSize="small"
                          />
                        </Grid>
                      </Grid>
                    </InputAdornment>
                  }
                  aria-describedby="filled-weight-helper-text"
                  inputProps={{
                    "aria-label": "weight",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  value={newBundleName}
                  onChange={onBundleNameTextChange}
                  autoFocus={true}
                />
              </FormControl>
            </Box>
          ) : (
            <Box sx={{ display: "flex" }}>
              <BorderColorOutlinedIcon
                sx={{
                  color: "#1b4a83",
                  "&:hover": {
                    borderColor: "#1b4a83",
                  },
                }}
                fontSize="small"
                onClick={(e) => {
                  e.stopPropagation();
                  handleEditBundle(
                    e,
                    bundledQuotes[0]?.bundleDetails?.bundleId,
                    bundledQuotes[0]?.bundleDetails?.bundleNameByUser,
                  );
                }}
              />
              <Typography
                noWrap
              >{`${bundledQuotes[0]?.bundleDetails?.bundleName}`}</Typography>
            </Box>
          )}
        </Grid>
        <Grid item sm={1}>
          <Typography noWrap>
            {getFormattedDiscount(
              bundledQuotes[0]?.bundleDetails?.bundleDiscount,
            )}{" "}
            %
          </Typography>
        </Grid>
        <Grid item sm={2}>
          <Typography noWrap>
            {bundledQuotes[0]?.bundleDetails?.createdBy}
          </Typography>
        </Grid>
        <Grid item sm={2}>
          <Typography noWrap>
            {moment(bundledQuotes[0]?.bundleDetails?.createdDate).format(
              "YYYY-MM-DD",
            )}
          </Typography>
        </Grid>
        <Grid item sm={1.5} zeroMinWidth>
          <Typography
            noWrap
            title={bundledQuotes[0]?.bundleDetails?.bundleProducts}
          >
            {bundledQuotes[0]?.bundleDetails?.bundleProducts &&
              bundledQuotes[0]?.bundleDetails?.bundleProducts
                .split(",")
                .slice(0, 2)
                .join(",") +
                (bundledQuotes[0]?.bundleDetails?.bundleProducts.length > 20
                  ? "..."
                  : "")}
          </Typography>
        </Grid>
        <Grid item sm={2}>
          <Typography noWrap>
            {bundledQuotes[0]?.bundleDetails?.totalRevenueIncCom?.toLocaleString(
              "en",
              {
                useGrouping: true,
                roundingMode: "trunc",
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              },
            )}
          </Typography>
        </Grid>
        <Grid item sm={2} sx={{ color: "#8A9123" }}>
          <Typography
            title={bundledQuotes[0]?.bundleDetails?.statusName}
            noWrap
          >
            {bundledQuotes[0]?.bundleDetails?.statusName}
          </Typography>
        </Grid>
        <Grid item sm={1}>
          <Box sx={{ display: "flex" }}>
            <Button
              variant="text"
              onClick={(e) => {
                e.stopPropagation();
                setCurrentBundleIdForAddNotes(
                  bundledQuotes[0]?.bundleDetails?.bundleId,
                );
                OpenAddBundleNotesDialog();
              }}
              sx={{ marginRight: -3 }}
            >
              <AddCircleOutlineOutlinedIcon />
            </Button>
            <Button
              variant="text"
              onClick={(e) => {
                e.stopPropagation();
                setCurrentBundleIdForViewNotes(
                  bundledQuotes[0]?.bundleDetails?.bundleId,
                );
                handleViewBundleNotes(
                  e,
                  bundledQuotes[0]?.bundleDetails?.bundleId,
                );
              }}
            >
              <VisibilityOutlinedIcon />
            </Button>
          </Box>
        </Grid>
        <Grid item sm={1}>
          <Button
            variant="text"
            className="btnRefresh"
            onClick={(e) => {
              e.stopPropagation();
              handleRefreshBundle(bundledQuotes[0]?.bundleDetails?.bundleId);
            }}
          >
            <RefreshIcon />
          </Button>
        </Grid>
      </Grid>
    );
  };

  const getFormattedCell = (key, quote) => {
    switch (quoteHeaders[key]) {
      case quoteHeaders?.productName:
        {
          return (
            <Link
              onClick={() => viewQuoteClick(quote?.quoteId)}
              className="viewLink"
            >
              {quote[key]}
            </Link>
          );
        }
        break;
      default:
        {
          return quote[key]?.toLocaleString("en", {
            useGrouping: true,
            roundingMode: "trunc",
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          });
        }
        break;
    }
  };

  const getCellBGColor = (key) => {
    return quoteHeaders[key] === quoteHeaders?.rateReqCurrency
      ? "lightgray"
      : "none";
  };
  const getCellTextColor = (key, quote) => {
    return quoteHeaders[key] === quoteHeaders?.statusName
      ? getStatusColor(quote[key])
      : "none";
  };

  const getStatusColor = (status) => {
    return statusColors?.[status];
  };

  const getBundleNoteComponent = () => {
    let existingBundleArray = [...bundleArray];
    let bundleObj = existingBundleArray.find(
      (b) => b[0]?.bundleDetails?.bundleId === currentBundleIdForViewNotes,
    );
    const notes = bundleObj[0].bundleDetails?.notes ?? [];
    return (
      <ViewBundleNotesDialog
        notes={notes}
        handleClose={CloseBundleNotesDialog}
        title={Constants.NOTESTITLE}
        show={showBundleNotesDialog}
      />
    );
  };

  const handleConfirmNotify = () => {
    debugger;
    sendNotificationToApprover();
    closeNotifyDialog();
  };

  const sendNotificationToApprover = () => {
    if (currentBundleIdForNotify && currentBundleIdForNotify !== null) {
      setNotifyInProgress(true);
      dispatch(notifyApproverForBundleApproval(currentBundleIdForNotify))
        .then((res) => {
          console.log(res);
          setNotifyInProgress(false);
          if (res == 1) {
            showNotification(
              Severity.SUCCESS,
              Constants.DIALOG_MESSAGE_NOTIFYAPPROVERSUCCESS,
            );
          } else {
            showNotification(
              Severity.ERROR,
              Constants.MESSAGE_SOMETHINGWENTWRONG,
            );
          }
        })
        .catch((e) => {
          console.log(e);
          setNotifyInProgress(false);
          showNotification(
            Severity.ERROR,
            Constants.MESSAGE_SOMETHINGWENTWRONG,
          );
        });
    }
  };

  const handleCancelNotify = () => {
    closeNotifyDialog();
  };

  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    const notifyObj = {
      bundleId: currentBundleIdForNotify,
      userId: value,
    };
    setNotifyApproverObject(notifyObj);
    setApproverError("");
    setApproverId(value);
  };

  const handleReject = (bundleId) => {
    setCurrentBundleIdForReject(bundleId);
    openRejectDialog();
  };

  const handleConfirmReject = () => {
    const rejectObj = {
      bundleId: currentBundleIdForReject,
      message: noteText,
      userId: loggedUser?.user?.id,
    };

    RejectTheBundle(rejectObj);
    closeRejectDialog();
  };

  const RejectTheBundle = (rejectObj) => {
    if (rejectObj) {
      setRejectInProgress(true);
      dispatch(rejectBundle(rejectObj))
        .then((res) => {
          setRejectInProgress(false);
          removeBundleFromList(rejectObj.bundleId);
          if (res == 1) {
            showNotification(
              Severity.SUCCESS,
              Constants.DIALOG_MESSAGE_BUNDLEREJECTSUCCESS,
            );
            setExpanded("");
          } else {
            showNotification(
              Severity.ERROR,
              Constants.DIALOG_MESSAGE_BUNDLEREJECTERROR,
            );
          }
        })
        .catch((e) => {
          console.log(e);
          setRejectInProgress(false);
          showNotification(
            Severity.ERROR,
            Constants.MESSAGE_SOMETHINGWENTWRONG,
          );
        });
    }
  };

  const handleEditBundle = (event, bundleId, bundleNameByUser) => {
    setNewBundleName(bundleNameByUser);
    setIsEditBundleName(true);
    setCurrentBundleIdForEditBundleName(bundleId);
  };

  const handleCancelEditBundleName = () => {
    setNewBundleName("");
    setIsEditBundleName(false);
    setCurrentBundleIdForEditBundleName(null);
  };

  const handleSaveBundleName = (event) => {
    saveOrUpdateBundleName();
    setIsEditBundleName(false);
    setCurrentBundleIdForEditBundleName(null);
  };

  const onBundleNameTextChange = (event) => {
    const newBundleName = event.target.value;
    console.log("newBundleName", newBundleName);
    setNewBundleName(newBundleName);
  };

  const saveOrUpdateBundleName = () => {
    if (
      currentBundleIdForEditBundleName &&
      currentBundleIdForEditBundleName !== null &&
      newBundleName !== undefined &&
      newBundleName !== null
    ) {
      const saveUpdateBundleNameObj = {
        bundleId: currentBundleIdForEditBundleName,
        bundleName: newBundleName,
        userId: loggedUser?.user?.id,
      };
      dispatch(saveBundleName(saveUpdateBundleNameObj))
        .then((res) => {
          if (res === 1) {
            updateBundleName(currentBundleIdForEditBundleName, newBundleName);
            showNotification(
              Severity.SUCCESS,
              Constants.MESSAGE_SAVEUPDATEBUNDLENAMESUCCESS,
            );
          } else {
            showNotification(
              Severity.ERROR,
              Constants.MESSAGE_SAVEUPDATEBUNDLENAMEERROR,
            );
          }
        })
        .catch((e) => {
          console.log(e);
          showNotification(
            Severity.ERROR,
            Constants.MESSAGE_SOMETHINGWENTWRONG,
          );
        });
    }
  };

  return (
    <>
      {bundleArray?.map((bundledQuotes, index) => (
        <>
          <Accordion
            className="parent-accordian"
            expanded={expanded === `panel${index}`}
            onChange={handleAccordianOnChange(`panel${index}`)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#1b4a83" }} />}
              aria-controls="panel1-content"
              id="panel1-header"
              className="bundleTableBoxHead"
            >
              {getManageBundleAccordianHeader(bundledQuotes)}
            </AccordionSummary>
            <Box sx={{ margin: 2.5 }}>
              <BundleOpportunityDetails
                opportunityDetails={bundledQuotes[0]?.opportunityDetails}
              />
            </Box>
            <ManageBundleActions
              bundleId={bundledQuotes[0]?.bundleDetails?.bundleId}
              handlePreviewDiscount={calculateDiscountOnBundle}
              handleApproveBundle={handleApproveButtonClick}
              handleRejectBundle={handleReject}
              handleNotifyClick={openNotifyDialog}
              rateSum={bundledQuotes[0]?.rateReqCurrencySum}
              bundleArrayIndex={index}
              showNotification={showNotification}
              loggedUser={loggedUser}
              canSubmit={bundledQuotes[0]?.canSubmit}
              canNotify={bundledQuotes[0]?.canNotify}
              canReject={bundledQuotes[0]?.canReject}
              approvalInProgress={approvalInProgress}
              notifyInProgress={notifyInProgress}
              rejectInProgress={rejectInProgress}
              pendingApproverRoles={
                bundledQuotes[0]?.bundleDetails?.pendingApproverRoles
              }
            />
            <AccordionDetails>
              <CurrentQuoteTableBox>
                <CompareQuotesTableWrap component={Paper}>
                  <Box className="tableContainer">
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          {Object.keys(quoteHeaders)?.map((key) => (
                            <TableCell>{quoteHeaders[key]}</TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {bundledQuotes?.map((quote) => (
                          <TableRow>
                            {Object.keys(quoteHeaders)?.map((key) => (
                              <TableCell
                                style={{
                                  backgroundColor: getCellBGColor(key),
                                  color: getCellTextColor(key, quote),
                                }}
                              >
                                {getFormattedCell(key, quote)}
                              </TableCell>
                            ))}
                          </TableRow>
                        ))}
                        <TableRow className="totalRow">
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                          <TableCell
                            sx={{
                              fontWeight: 600,
                              textAlign: "center",
                              color: "#1b4a83",
                            }}
                          >
                            Total
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>
                            {bundleArray[
                              index
                            ][0]?.rateReqCurrencySum?.toLocaleString("en", {
                              useGrouping: true,
                              roundingMode: "trunc",
                              maximumFractionDigits: 2,
                              minimumFractionDigits: 2,
                            })}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>
                            {bundleArray[index][0]?.currencyCode}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>
                            {bundleArray[index][0]?.rateUsdSum?.toLocaleString(
                              "en",
                              {
                                useGrouping: true,
                                roundingMode: "trunc",
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2,
                              },
                            )}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>
                            {bundleArray[index][0]?.totalTcvCad?.toLocaleString(
                              "en",
                              {
                                useGrouping: true,
                                roundingMode: "trunc",
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2,
                              },
                            )}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>
                            {bundleArray[index][0]?.pricingStructureName}
                          </TableCell>
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>
                </CompareQuotesTableWrap>
              </CurrentQuoteTableBox>
              <Box className="accountDataBox">
                <AccountDataRevenueCard
                  data={` ${
                    bundledQuotes?.[0]?.bundleRevenue?.totalRevenueIncCom
                      ? `
                            ${
                              bundledQuotes?.[0]?.currencyCode
                            } ${bundledQuotes?.[0]?.bundleRevenue?.totalRevenueIncCom?.toLocaleString(
                              "en",
                              {
                                useGrouping: true,
                                roundingMode: "trunc",
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2,
                              },
                            )}`
                      : bundledQuotes?.[0]?.currencyCode + " 0.00"
                  }`}
                  header={"Total revenue"}
                  subheader={"(Incl. commission)"}
                />
                <AccountDataRevenueCard
                  data={`${
                    bundledQuotes?.[0]?.bundleRevenue?.annualRevenueWOCom
                      ? `
                          ${bundledQuotes?.[0]?.currencyCode} 
                          ${bundledQuotes?.[0]?.bundleRevenue?.annualRevenueWOCom?.toLocaleString(
                            "en",
                            {
                              useGrouping: true,
                              roundingMode: "trunc",
                              maximumFractionDigits: 2,
                              minimumFractionDigits: 2,
                            },
                          )}`
                      : bundledQuotes?.[0]?.currencyCode + " 0.00"
                  }`}
                  header={"Annual revenue for WPO"}
                  subheader={"(W/o commission)"}
                />
                <AccountDataRevenueCard
                  data={`${
                    bundledQuotes?.[0]?.bundleRevenue?.totalRevenueIncComUSD
                      ? `USD ${bundledQuotes?.[0]?.bundleRevenue?.totalRevenueIncComUSD?.toLocaleString(
                          "en",
                          {
                            useGrouping: true,
                            roundingMode: "trunc",
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          },
                        )}`
                      : "USD 0.00"
                  }`}
                  header={"USD Total revenue"}
                  subheader={"(Incl. commission)"}
                />
                <AccountDataRevenueCard
                  data={`${
                    bundledQuotes?.[0]?.bundleRevenue?.annualRevenueWOComUSD
                      ? `
                            USD ${bundledQuotes?.[0]?.bundleRevenue?.annualRevenueWOComUSD?.toLocaleString(
                              "en",
                              {
                                useGrouping: true,
                                roundingMode: "trunc",
                                maximumFractionDigits: 2,
                                minimumFractionDigits: 2,
                              },
                            )}`
                      : "USD 0.00"
                  }`}
                  header={"USD Annual revenue for WPO"}
                  subheader={"(W/o commission)"}
                />
              </Box>
            </AccordionDetails>
            {loading && (
              <Backdrop
                className="backdrop"
                sx={{
                  color: "#000",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={loading}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
            )}
          </Accordion>

          {showDuplicateDialogBox && (
            <OkayDialog
              openDialog={showDuplicateDialogBox}
              handleOkayClick={handleOkayToDuplicateQuotesInBundle}
              title={Constants.CONFIRM}
              imgsrc={checkIcon}
              description={Constants.DIALOG_MESSAGE_PROMPTDUPLICATEBUNDLE}
            />
          )}
          {showBundleNotesDialog && getBundleNoteComponent()}
          {showAddBundleNotes && (
            <AddBundleNoteDialog
              dialogText={noteText}
              show={showAddBundleNotes}
              title={Constants.NOTEBANNER}
              heading={Constants.NOTEHEADING}
              imgsrc={checkIcon}
              popupType={DialogConstants.NOTE}
              handleTextBoxChange={handleDialogTextChange}
              handleConfirmClick={handleAddBundleNote}
              handleCancelClick={CloseAddBundleNotesDialog}
            />
          )}
          {showNotifyDialog && (
            <ConfirmationDialog
              openDialog={showNotifyDialog}
              handleOkayClick={handleConfirmNotify}
              handleCancelClick={handleCancelNotify}
              title={Constants.NOTIFYBANNER}
              description={Constants.NOTIFYHEADING}
            />
            // <AddBundleNoteDialog
            //   dialogText={noteText}
            //   show={showNotifyDialog}
            //   title={Constants.NOTIFYBANNER}
            //   heading={Constants.NOTIFYHEADING}
            //   imgsrc={checkIcon}
            //   popupType={DialogConstants.APPROVE}
            //   showError={approverError}
            //   samLeadershipList={samLeadershipData}
            //   textboxError={dialogError}
            //   handleTextBoxChange={handleDialogTextChange}
            //   handleSelectChange={handleSelectChange}
            //   handleConfirmClick={handleConfirmNotify}
            //   handleCancelClick={handleCancelNotify}
            // />
          )}
          {showRejectDialog && (
            <AddBundleNoteDialog
              show={showRejectDialog}
              title={Constants.REJECTBANNER}
              heading={Constants.REJECTHEADING}
              imgsrc={closeIcon}
              handleTextBoxChange={handleDialogTextChange}
              popupType={DialogConstants.REJECT}
              dialogText={noteText}
              handleCancelClick={closeRejectDialog}
              handleConfirmClick={handleConfirmReject}
            />
          )}
          {isApprovalWorkflowDialogVisible && (
            <ApprovalWorkflowDialog
              show={isApprovalWorkflowDialogVisible}
              title={Content.APPROVEBANNER}
              heading={Content.APPROVEHEADING}
              approverId={approverId}
              dialogText={dialogText}
              popupType={Content.APPROVE}
              showError={approverError}
              imgsrc={checkIcon}
              textboxError={dialogError}
              handleTextBoxChange={handleTextBoxChange}
              approverUsers={availableApprovers}
              selectedApprovers={selectedApprovers}
              setSelectedApprovers={setSelectedApprovers}
              handleConfirmClick={handleDialogConfirmApprove}
              handleCancelClick={closeApprovalWorkflowDialog}
              dialogApproverRoles={dialogApproverRoles}
              isOptionalApprover={isOptionalApprover}
            />
          )}
        </>
      ))}
    </>
  );
};

export default ManageBundleAccordian;
